class TestimonialsCarousel {
  constructor(sectionId) {
    (this.sectionId = sectionId),
      (this.carousel = document.getElementById(`testimonials-${sectionId}`)),
      this.carousel &&
        ((this.track = this.carousel.querySelector(".testimonials-track")),
        (this.originalCards =
          this.carousel.querySelectorAll(".testimonial-card")),
        (this.prevButton = this.carousel.querySelector(".nav-button.prev")),
        (this.nextButton = this.carousel.querySelector(".nav-button.next")),
        (this.dots = this.carousel.querySelectorAll(".dot")),
        (this.isMobile = window.innerWidth < 750),
        (this.isAnimating = !1),
        (this.touchStartX = 0),
        (this.touchStartY = 0),
        (this.touchEndX = 0),
        (this.touchEndY = 0),
        (this.isSwiping = !1),
        this.init());
  }
  init() {
    this.setupCards(),
      this.bindEvents(),
      setTimeout(() => this.updateCarousel(!1), 100);
  }
  setupCards() {
    if (this.isMobile)
      if (this.originalCards.length > 1) {
        const lastCardClone = this.originalCards[
            this.originalCards.length - 1
          ].cloneNode(!0),
          firstCardClone = this.originalCards[0].cloneNode(!0);
        lastCardClone.classList.add("testimonial-clone", "mobile-clone-before"),
          firstCardClone.classList.add(
            "testimonial-clone",
            "mobile-clone-after"
          ),
          this.track.insertBefore(lastCardClone, this.track.firstChild),
          this.track.appendChild(firstCardClone),
          (this.cards = this.track.querySelectorAll(".testimonial-card")),
          (this.currentSlide = 1),
          (this.totalSlides = this.originalCards.length);
      } else
        (this.cards = this.originalCards),
          (this.currentSlide = 0),
          (this.totalSlides = this.originalCards.length);
    else if (this.originalCards.length > 1) {
      const clonesBefore = Array.from(this.originalCards).map((card) => {
          const clone = card.cloneNode(!0);
          return (
            clone.classList.add("testimonial-clone", "clone-before"), clone
          );
        }),
        clonesAfter = Array.from(this.originalCards).map((card) => {
          const clone = card.cloneNode(!0);
          return clone.classList.add("testimonial-clone", "clone-after"), clone;
        });
      clonesBefore.forEach((clone) =>
        this.track.insertBefore(clone, this.track.firstChild)
      ),
        clonesAfter.forEach((clone) => this.track.appendChild(clone)),
        (this.cards = this.track.querySelectorAll(".testimonial-card")),
        (this.currentSlide = this.originalCards.length),
        (this.totalSlides = this.originalCards.length);
    } else
      (this.cards = this.originalCards),
        (this.currentSlide = 0),
        (this.totalSlides = this.originalCards.length);
  }
  updateCarousel(animate = !0) {
    if (!this.cards[this.currentSlide]) return;
    if (this.isMobile) {
      const targetCard = this.cards[this.currentSlide];
      if (!targetCard) return;
      const containerRect = this.carousel.getBoundingClientRect(),
        cardRect = targetCard.getBoundingClientRect(),
        containerCenter = containerRect.left + containerRect.width / 2,
        cardCenter = cardRect.left + cardRect.width / 2,
        currentTransform = getComputedStyle(this.track).transform;
      let currentOffset = 0;
      currentTransform &&
        currentTransform !== "none" &&
        (currentOffset = new DOMMatrix(currentTransform).m41);
      const centeringError = cardCenter - containerCenter,
        newOffset = currentOffset - centeringError;
      animate
        ? (this.track.style.transition = "transform 0.3s ease")
        : (this.track.style.transition = "none"),
        (this.track.style.transform = `translateX(${newOffset}px)`),
        this.originalCards.length > 1 &&
          (this.currentSlide === 0
            ? setTimeout(
                () => {
                  (this.currentSlide = this.totalSlides),
                    this.updateCarousel(!1);
                },
                animate ? 300 : 0
              )
            : this.currentSlide === this.totalSlides + 1 &&
              setTimeout(
                () => {
                  (this.currentSlide = 1), this.updateCarousel(!1);
                },
                animate ? 300 : 0
              ));
    } else {
      const cardWidth = this.cards[0].offsetWidth,
        gap = parseInt(getComputedStyle(this.track).gap) || 0,
        containerWidth = this.carousel.offsetWidth,
        cardPosition = (cardWidth + gap) * this.currentSlide,
        centerOffset = containerWidth / 2 - cardWidth / 2,
        twoCardsOffset = (cardWidth + gap) * 2,
        newOffset = -(cardPosition - centerOffset + twoCardsOffset);
      animate
        ? (this.track.style.transition = "transform 0.3s ease")
        : (this.track.style.transition = "none"),
        (this.track.style.transform = `translateX(${newOffset}px)`),
        this.originalCards.length > 1 &&
          setTimeout(
            () => {
              this.currentSlide < this.totalSlides
                ? ((this.currentSlide = this.totalSlides + this.currentSlide),
                  this.updateCarousel(!1))
                : this.currentSlide >= this.totalSlides * 2 &&
                  ((this.currentSlide =
                    this.totalSlides +
                    (this.currentSlide - this.totalSlides * 2)),
                  this.updateCarousel(!1));
            },
            animate ? 350 : 10
          );
    }
    this.prevButton && (this.prevButton.disabled = !1),
      this.nextButton && (this.nextButton.disabled = !1);
    let realCardIndex;
    this.isMobile
      ? this.originalCards.length > 1
        ? (realCardIndex =
            this.currentSlide === 0
              ? this.totalSlides - 1
              : this.currentSlide === this.totalSlides + 1
              ? 0
              : this.currentSlide - 1)
        : (realCardIndex = this.currentSlide)
      : this.currentSlide < this.totalSlides
      ? (realCardIndex = this.currentSlide)
      : this.currentSlide >= this.totalSlides * 2
      ? (realCardIndex = this.currentSlide - this.totalSlides * 2)
      : (realCardIndex = this.currentSlide - this.totalSlides),
      this.dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === realCardIndex);
      });
  }
  bindEvents() {
    this.prevButton &&
      this.prevButton.addEventListener("click", () => {
        this.isAnimating ||
          ((this.isAnimating = !0),
          this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide--
              : (this.currentSlide =
                  this.currentSlide === 0
                    ? this.totalSlides - 1
                    : this.currentSlide - 1)
            : this.currentSlide--,
          this.updateCarousel(),
          setTimeout(() => {
            this.isAnimating = !1;
          }, 350));
      }),
      this.nextButton &&
        this.nextButton.addEventListener("click", () => {
          this.isAnimating ||
            ((this.isAnimating = !0),
            this.isMobile
              ? this.originalCards.length > 1
                ? this.currentSlide++
                : (this.currentSlide =
                    this.currentSlide === this.totalSlides - 1
                      ? 0
                      : this.currentSlide + 1)
              : this.currentSlide++,
            this.updateCarousel(),
            setTimeout(() => {
              this.isAnimating = !1;
            }, 350));
        }),
      this.dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.isAnimating ||
            ((this.isAnimating = !0),
            this.isMobile
              ? this.originalCards.length > 1
                ? (this.currentSlide = index + 1)
                : (this.currentSlide = index)
              : (this.currentSlide = this.totalSlides + index),
            this.updateCarousel(),
            setTimeout(() => {
              this.isAnimating = !1;
            }, 350));
        });
      }),
      this.bindTouchEvents(),
      window.addEventListener("resize", () => {
        setTimeout(() => this.updateCarousel(!1), 50);
      });
  }
  bindTouchEvents() {
    const handleTouchStart = (e) => {
        this.isAnimating ||
          ((this.touchStartX = e.touches[0].clientX),
          (this.touchStartY = e.touches[0].clientY),
          (this.isSwiping = !0));
      },
      handleTouchMove = (e) => {
        if (!this.isSwiping) return;
        (this.touchEndX = e.touches[0].clientX),
          (this.touchEndY = e.touches[0].clientY);
        const deltaX = this.touchEndX - this.touchStartX,
          deltaY = this.touchEndY - this.touchStartY;
        Math.abs(deltaX) > Math.abs(deltaY) &&
          Math.abs(deltaX) > 20 &&
          e.preventDefault();
      },
      handleTouchEnd = (e) => {
        if (!this.isSwiping || this.isAnimating) return;
        const deltaX = this.touchEndX - this.touchStartX,
          deltaY = this.touchEndY - this.touchStartY;
        Math.abs(deltaX) > Math.abs(deltaY) &&
          Math.abs(deltaX) > 50 &&
          ((this.isAnimating = !0),
          deltaX > 0
            ? this.isMobile
              ? this.originalCards.length > 1
                ? this.currentSlide--
                : (this.currentSlide =
                    this.currentSlide === 0
                      ? this.totalSlides - 1
                      : this.currentSlide - 1)
              : this.currentSlide--
            : this.isMobile
            ? this.originalCards.length > 1
              ? this.currentSlide++
              : (this.currentSlide =
                  this.currentSlide === this.totalSlides - 1
                    ? 0
                    : this.currentSlide + 1)
            : this.currentSlide++,
          this.updateCarousel(!0),
          setTimeout(() => {
            this.isAnimating = !1;
          }, 350)),
          (this.isSwiping = !1);
      };
    this.track.addEventListener("touchstart", handleTouchStart, {
      passive: !1,
    }),
      this.track.addEventListener("touchmove", handleTouchMove, {
        passive: !1,
      }),
      this.track.addEventListener("touchend", handleTouchEnd, { passive: !0 }),
      this.track.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="testimonials-"]').forEach((container) => {
    const sectionId = container.id.replace("testimonials-", "");
    new TestimonialsCarousel(sectionId);
  });
});
//# sourceMappingURL=/cdn/shop/t/6/assets/testimonials-carousel.js.map

